
<div class="content">

  <div class="row">
    <div class="col-12">
      <div class="header-wrapper">
        <div class="company">
          {{data.COMPANY_NAME}}
        </div>
      </div>
    </div>
  </div>

  <!--<div class="row data-row" *ngIf="data.ADDRESS">
    <div class="col-12">
      <label>Address</label>
      <div class="value">
        {{data.ADDRESS?.length > 0 && data.ADDRESS != null ? data.ADDRESS+", " : ""}}
        {{data.ADDRESS2?.length > 0 && data.ADDRESS2 != null ? data.ADDRESS2+", " : ""}}
        {{data.CITY}}, {{data.STATE}} {{data.ZIP}}
      </div>
    </div>
  </div>

  <div class="row data-row" *ngIf="data.PHONE">
    <div class="col-12">
      <label>Phone</label>
      <div class="value">
        <a href="tel://{{data.PHONE}}">{{data.PHONE}}</a>
      </div>
    </div>
  </div>

  <div class="row data-row" *ngIf="data.FAX">
    <div class="col-12">
      <label>Fax</label>
      <a href="tel://{{data.FAX}}">{{data.FAX}}</a>
    </div>
  </div>

  <div class="row data-row" *ngIf="data.WEB">
    <div class="col-12">
      <label>Web</label>
      <a [href]="data.WEB">{{data.WEB}}</a>
    </div>
  </div>-->
  <div class="row data-row">
    <div class="col-12">
      <label>Domains</label>
      <div class="value">{{data.DOMAINS}}</div>
    </div>
  </div>

  <div class="row data-row">
    <div class="col-12">
      <label>Notes</label>
      <div class="value notes">{{data.NOTES}}</div>
    </div>
  </div>

</div>
